import { BaseModule, EventBus } from '@mc/tangram-core'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
// import { login } from '@/utils/native_interactions/login'
import { API } from '@/api'

export class Lottery extends BaseModule {
  id = ''
  name = ''
  events = {
    lotteryTicker: 'lottery-ticker',
    getLotteryResult: 'get-lottery-result'
  }

  EventBus = new EventBus()

  activityInfo = {
    id: 0,
    msg: ''
  }

  // 会员积分新增
  lottoType = 1
  score = 0
  currentTotalScore = 0

  constructor(options) {
    super(options)

    switch (Number(options.layoutType)) {
      case 1:
        this.name = 'sudoku_machine'
        break
      case 2:
        this.name = 'slot_machine'
        break
    }

    const shouldBuildModule = !!options.data.lotteryData

    if (shouldBuildModule) {
      this.id = options.id
      this.backgroundImage = options.style.bgImg
      // eslint-disable-next-line camelcase
      this.buttonImage = options.style.buttonImg?.img_url
      // eslint-disable-next-line camelcase
      this.gridImage = options.style.gridImg?.img_url
      this.infoMap = this.computeInfoMap(options.data.lotteryData)
      this.lotteryStatus = {
        status: options.data.status,
        alert: options.data.alert
      }
      this.tickerInfo = options.data.tickerInfo

      this.EventBus.on(this.events.lotteryTicker, () => {
        this.lotteryTicker()
      })

      this.EventBus.on(this.events.getLotteryResult, () => {
        this.getLotteryResult()
      })
    } else {
      return {}
    }
  }

  computeInfoMap(data) {
    const list = data.prize_list
    if (!list.length) return []
    const maps = []

    list.forEach(item => {
      maps.push(item)
    })

    this.activityInfo.id = data.activity_id
    this.remainNum = data.remain_num
    this.lottoType = data.lottoType
    this.score = data.score
    this.currentTotalScore = data.currentTotalScore
    return maps
  }

  async getLotteryResult() {
    let lotteryResult = '很遗憾，您与大奖失之交臂，请再接再厉哦！'
    let ret = 0
    let showSeq = 0
    try {
      const res = await API.lottery.getLotteryLuck({
        lottery_activity_id: this.activityInfo.id,
        lottoType: this.lottoType,
        score: this.score
      })
      ret = 1
      this.currentTotalScore = res.currentTotalScore
      if (res.status) {
        showSeq = res.prize.show_seq
        lotteryResult = '好运到啦，恭喜您获得' + res.prize.prize_name
      }
    } catch (err) {
      if (err.res && err.res.error && err.res.error.msg) {
        lotteryResult = err.res.error.msg
      }
      if (err.res && err.res.error && Number(err.res.error.code) === 1012002) {
        // login()
      }
    }
    this.postMessage(this.events.getLotteryResult, {
      ret,
      lotteryResult,
      showSeq,
      currentTotalScore: this.currentTotalScore
    })
  }

  lotteryTicker() {
    const tickerInfo = this.tickerInfo
    if (tickerInfo?.click) {
      tracerVuePlugin.click(
        tickerInfo.click.spm,
        Object.assign({}, tickerInfo.click.spmJson, tickerInfo.data)
      )
    }
  }

  render() {
    const {
      id,
      pageId,
      name,
      events,
      containerStyle,
      backgroundImage,
      buttonImage,
      gridImage,
      infoMap,
      remainNum,
      tickerInfo,
      activityInfo,
      lotteryStatus,
      lottoType,
      score,
      currentTotalScore
    } = this
    return {
      id,
      pageId,
      renderIdentifier: name,
      events,
      containerStyle,
      backgroundImage,
      buttonImage,
      gridImage,
      infoMap,
      remainNum,
      tickerInfo,
      activityInfo,
      lotteryStatus,
      lottoType,
      score,
      currentTotalScore
    }
  }
}
